<div
  id="service-details-metric-card"
  class="flex flex-col w-full p-4 bg-white box-border rounded-lg gap-1 border-solid border-1 border-sky-blue"
>
  <section
    id="service-details-metric-card-header"
    class="text-base font-bold text-shuttle-gray"
  >
    {{ metricName }}
  </section>
  <section id="service-details-metric-card-body" class="flex gap-2">
    <div
      id="service-details-metric-card-value"
      class="text-4xl text-neptune-color-secondary-800"
    >
      {{ totalCount }}
    </div>

    <ng-container *ngIf="growthDateRangeAvailable">
      <div class="growth-block flex items-center">
        <span class="arrow flex items-center">
          <img
            class="w-5 h-5 block"
            src="/assets/shared-icons/neptune-icon-blue-solid-chevron-down.svg"
            alt="growth-arrow-icon"
            [ngClass]="percentGrowth >= 0 ? 'rotate-180' : ''"
          />
        </span>
        <span
          class="growth-value font-medium text-neptune-color-primary-500"
        >
          {{ this.percentGrowth | signedNumber }}%
        </span>
      </div>
    </ng-container>
  </section>
</div>
